import { Injectable } from '@angular/core';
import { GeneralConstants } from 'src/app/core/constants/general.constants';
import { CashOutRequest } from 'src/app/core/models/request/cash-out-request';
import { VirtualAccountBalanceModel } from 'src/app/core/models/virtual-account-balance.model';
import { NotificationService } from 'src/app/core/services/notification.service';
import { NotificationModel } from '../models/notification.model';
import { IdentityService } from './identity.service';
import { RestService } from './rest.service';
import { BaseResponseClass } from '../models/response/base-response-class.model';

/**
 * PaymentService
 * @description
 * Permite la comunicación con el circuito de pago de Yacaré-Core.
 */
@Injectable()
export class BalanceService {
  private notifications: NotificationModel[];
  private decimalBalance: string;
  private enteroBalance: number;

  constructor(
    private rest: RestService,
    private notificationService: NotificationService,
    private identityService: IdentityService
  ) {}

  get getBalanceDecimal() {
    return this.decimalBalance;
  }

  get getBalanceEntero() {
    return this.enteroBalance;
  }

  set setBalanceDecimal(decimal: string) {
    this.decimalBalance = decimal;
  }

  set setBalanceEntero(entero: number) {
    this.enteroBalance = entero;
  }

  public getBalance(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.rest
        .post(GeneralConstants.getAccountState, null)
        .then((response) => {
          if (response.object) {
            let cash = +response.object.accountBalance;
            let [currencyInt, currencyDec] = cash.toFixed(2).split('.');
            this.setBalanceDecimal = currencyDec;
            this.setBalanceEntero = +currencyInt;
          }
          resolve(response.object);
        })
        .catch((error) => {
          reject(new Error(error.message));
        });
    });
  }

  public cashOut(cashOutRequest: CashOutRequest): Promise<any> {
    return new Promise((resolve, reject) => {
      this.rest
        .post(GeneralConstants.cashOut, cashOutRequest)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(new Error(error.message));
        });
    });
  }

  public cashIn(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.rest
        .post(GeneralConstants.cashIn, null)
        .then((response) => {
          resolve(response.object);
        })
        .catch((error) => {
          reject(new Error(error.message));
        });
    });
  }

  public async getTransaccionId(): Promise<String> {
    return new Promise<String>((resolve, reject) => {
      this.rest
        .get(GeneralConstants.getTransaccionId)
        .then((response) => {
          resolve(response.object);
        })
        .catch((error) => {
          throw this.notificationService.mgsView({
            error: 404,
            messenger: error.message,
            title: 'Yacaré',
            type: 2,
            configNotification: null
          });
        });
    });
  }

  public getVirtualAccountBalance(): Promise<VirtualAccountBalanceModel> {
    return new Promise((resolve, reject) => {
      this.rest
        .get(GeneralConstants.virtualAccountBalance)
        .then((response) => {
          let balance = new VirtualAccountBalanceModel();

          balance.generalBalance = response.object.generalBalance;
          balance.availableBalance = response.object.availableBalance;
          balance.toCollectBalance = response.object.toCollectBalance;

          resolve(balance);
        })
        .catch((error) => {
          reject(new Error(error.message));
        });
    });
  }

  public async getHolder(cvu: string): Promise<BaseResponseClass> {
    return new Promise<BaseResponseClass>((resolve, reject) => {
      this.rest
        .post(GeneralConstants.getHolderTransfer, { cbuAlias: cvu })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error.message);
        });
    });
  }
}
